import type { ActivityCockpitSnapshot } from '@internal/spassu-code-contract';
import type { CockpitHeaderView } from './cockpitViewModel';
import { activityStatusLabel, evidenceConditionLabel } from './semanticLabels';

export function createCockpitHeaderView(
  snapshot: ActivityCockpitSnapshot,
  viaLabel: string,
): CockpitHeaderView {
  const summary = snapshot.sections.summary;
  if (!summary.value) throw new Error('Cockpit summary is unavailable.');
  return {
    title: summary.value.activity.title,
    viaLabel,
    statusLabel: activityStatusLabel(summary.value.activity.status),
    evidenceLabel: evidenceConditionLabel(summary.status, summary.coverage),
    updatedAt: snapshot.generatedAt,
    historical: snapshot.historical,
    revision: snapshot.revision,
  };
}
